import { TEMPLATE_IDS } from './templateLoader';
import type { TemplateId } from './templateLoader';

/**
 * Mapping between frontend template string IDs and backend numeric IDs
 * Backend expects: 1 = parking, 2 = construction, 3 = factory
 */
export const TEMPLATE_ID_TO_NUMBER: Record<TemplateId, number> = {
  [TEMPLATE_IDS.PARKING]: 1,
  [TEMPLATE_IDS.CONSTRUCTION]: 2,
  [TEMPLATE_IDS.FACTORY]: 3,
} as const;

/**
 * Reverse mapping: numeric ID to template string ID
 */
export const NUMBER_TO_TEMPLATE_ID: Record<number, TemplateId> = {
  1: TEMPLATE_IDS.PARKING,
  2: TEMPLATE_IDS.CONSTRUCTION,
  3: TEMPLATE_IDS.FACTORY,
} as const;

/**
 * Convert template string ID to backend numeric ID
 */
export function templateIdToNumber(templateId: TemplateId): number {
  const numericId = TEMPLATE_ID_TO_NUMBER[templateId];
  if (numericId === undefined) {
    throw new Error(`Unknown template ID: ${templateId}`);
  }
  return numericId;
}

/**
 * Convert backend numeric ID to template string ID
 */
export function numberToTemplateId(numericId: number): TemplateId {
  const templateId = NUMBER_TO_TEMPLATE_ID[numericId];
  if (templateId === undefined) {
    throw new Error(`Unknown numeric template ID: ${numericId}`);
  }
  return templateId;
}
